// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"beeae2b8","316":"49b53205","421":"49b53205","727":"49b53205","772":"100c7b87","807":"17bccf16","955":"b90e900a"}[chunkId] + ".chunk.css";
};